import React from "react";
import { informations } from "../data/SiteData";
function Footer(props) {
  return (
    <footer id="footer">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="footer-info">
                <h3 style={{ color: "#444444" }}>{informations.name}</h3>
                <p>
                  {informations.address}
                  <br />
                  {informations.city}
                  <br />
                  <br />
                  <strong>Phone:</strong>
                  <a href="callto:+93786702440" style={{ color: "#cc1616" }}>
                    {" "}
                    {informations.phone1}
                  </a>
                  <br />
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:qanoonisuhaib@aol.com"
                    style={{ color: "#cc1616" }}
                  >
                    {" "}
                    {informations.email}
                  </a>
                  <br />
                </p>
                <div class="social-links mt-3">
                  <a href={informations.twitter} class="twitter">
                    <i class="bx bxl-twitter"></i>
                  </a>
                  <a href={informations.facebook} class="facebook">
                    <i class="bx bxl-facebook"></i>
                  </a>
                  <a href={informations.instagram} class="instagram">
                    <i class="bx bxl-instagram"></i>
                  </a>
                  <a href={informations.linkedin} class="linkedin">
                    <i class="bx bxl-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Home</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">About us</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Services</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Terms of service</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Privacy policy</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-2 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Web Design</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Web Development</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Mobile App Development</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Database Development</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>{" "}
                  <a href="#">Graphic Design</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-6 footer-newsletter">
              <h4>Our Newsletter</h4>
              <p>Newsletter will appear here once a month</p>
              {/* <form action="" method="post">
                <input type="email" name="email" />
                <a href="../../ComingSoon/index.html">Subscribe</a>
              </form> */}
              <br />
              <br />
              <h3 style={{ color: "#444444" }}>{informations.title}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>{informations.title}</span>
          </strong>
          . All Rights Reserved
        </div>
        <div class="credits">
          Designed by{" "}
          <a href="https://suhaib-islam.netlify.app/">
            {informations.developer}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
